import React, { FC } from 'react';
import { FormikHelpers } from 'formik';
import StarRating from '../../../../library/inputs/rating/StarRating';

interface Props {
  id: string;
  value: string;
  setFieldTouched: FormikHelpers<string>['setFieldTouched'];
  setFieldValue: FormikHelpers<string>['setFieldValue'];
  color: string | undefined;
  count: number | undefined;
  allowHalf: boolean | undefined;
  readOnlyMode?: boolean;
}

const RatingField: FC<Props> = ({
  id,
  value,
  setFieldTouched,
  setFieldValue,
  count,
  allowHalf,
  color,
  readOnlyMode,
}: Props) => {
  return (
    <div>
      <StarRating
        color={color}
        value={parseFloat(value) ? parseFloat(value) : 0}
        count={count}
        fontSize={30}
        allowHalf={allowHalf}
        onChange={async (val) => {
          await setFieldValue(id, val.toString(), true);
          await setFieldTouched(id, true, true);
        }}
        readOnlyMode={readOnlyMode}
      />
    </div>
  );
};

export default RatingField;
